import React from "react";
import { Routes, Route } from "react-router-dom";
import { NotFound } from "navigation/NotFound";
import {
  ROOT,
  TRAINEE_DETAILS,
  ATTENDANCE,
  NEW_ROSTER_CONFIG,
  ROSTER_CONFIG,
  PII_RITM_REPORT,
  PII_FACILITIES_REPORT,
  NEW_HOME,
  PARENT_CLIENT,
  SEARCH_RESULT,
  REQUISITION_SEARCH,
  ROSTER_SEARCH,
  BULK_EDIT,
  PII_REPORT,
  PII_REPORT_BY_ORACLEID,
  CREATE_IDM_TICKET,
  MILESTONES,
  CREATEMILESTONES,
  WELCOME,
  SHIPPING_REPORT,
} from "navigation/CONSTANTS";
import { SearchResult } from "pages/SearchResult";
import RequisitionSearch from "../pages/RequisitionSearch/RequisitionSearch";
import RosterSearch from "../pages/RosterSearch/RosterSearch";
import ParentClient from "../pages/ParentClient/ParentClient";
import Attendance from "../components/BulkEdit/Attendance/Attendance";
import RosterConfig from "../pages/RosterConfig/RosterConfig";
import NewRosterConfig from "../pages/RosterConfigLayout/RosterConfig";
import BulkEdit from "../pages/BulkEdit/BulkEdit";
import Login from "./Auth/Login/Login";
import TraineeDetails from "../pages/TraineeDetailsHome/TraineeDetailsHome";
import PIIReport from "../pages/PIIReport/PIIReport";
import PIIReportByOracleId from "../pages/PIIReportByOracleId/PIIReportByOracleId";
import OBTInfoManagement from "../pages/OBTInfoManagement/OBTInfoManagement";
import IDMOGOwnerShip from "components/IDMOGOwnership/IDMOGOwnership";
import BulkEditIDMOGOwnerShip from "components/IDMOGOwnership/BulkEditIDMOGOwnership";
import PIIReportByRITM from "../pages/PIIReportByRITM/PIIReportByRITM";
import PIIReportByFacilities from "../pages/PIIReportByFacilities/PIIReportByFacilities";
import AssignTrainees from "components/AssignTrainees/AssignTrainees";
import CreateIDMTicket from "components/CreateIDMTicket/CreateIDMTicket";
import MileStones from "pages/MileStones/MileStones";
import CreateMilestones from "pages/MileStones/CreateMilestones";
import Welcome from "pages/Welcome/Welcome";
import CenterPointLayout from "pages/CenterPointLayout/CenterPointLayout";
import LearnPointLayout from "pages/LearnPointLayout/LearnPointLayout";
import AsttHome from "../pages/Home/AsttHome";
import SearchRequests from "components/SearchClassRoster/SearchRequests";
import SearchTrainees from "components/SearchClassRoster/SearchTrainees";
import SearchRequisitions from "components/SearchClassRoster/SearchRequisitions";
import SearchRosters from "components/SearchClassRoster/SearchRosters";
import RosterManagement from "components/SearchClassRoster/RosterManagement";
import RosterConfigInputs from "components/RosterConfig/RosterConfigInputs";
import GenerateIdmTicket from "components/GenerateIdmTicket/GenerateIdmTicket";
import CreateUpdateClassRequest from "components/ClassRequest/CreateUpdateClassRequest";
import ShippingReportAccess from "pages/ShippingReportByRITM/ShippingReportAccess";
import CoreRatioLayout from "pages/CoreRatioLayout/CoreRatioLayout";
import BIReportLayout from "pages/BIReportLayout/BIReportLayout";
export const RouterConfig = () => {
  return (
    <Routes>
      {/* Root and Authentication Routes */}
      <Route path={ROOT} element={<Login />} />
      <Route path={WELCOME} element={<Welcome />} />

      {/* Home Routes - Nested under /home */}
      <Route path="/home" element={<AsttHome />}>
        <Route path="searchrequests" element={<SearchRequests />} />
        <Route path="searchtrainees" element={<SearchTrainees />} />
        <Route path="searchrequisitions" element={<SearchRequisitions />} />
        <Route path="searchrosters" element={<SearchRosters />} />
        <Route path="rosterbulkedit" element={<RosterManagement />} />
        <Route path="rosterconfig" element={<RosterConfigInputs />} />
        <Route path="generateidmticket" element={<GenerateIdmTicket />} />
        <Route
          path="createclassrequest"
          element={<CreateUpdateClassRequest />}
        />
        <Route path="assignTrainees" element={<AssignTrainees />} />
      </Route>

      {/* OBT Info Management Routes - Nested under /obtinfo */}
      <Route path="/obtinfo" element={<OBTInfoManagement />}>
        <Route path=":Type" element={<OBTInfoManagement />} />
        <Route path="accountOwnership" element={<IDMOGOwnerShip />} />
        <Route
          path="bulkEditAccountOwnerShip"
          element={<BulkEditIDMOGOwnerShip />}
        />
        <Route path="createMilestones" element={<CreateMilestones />} />
        <Route path="assignMilestones" element={<MileStones />} />
      </Route>

      {/* LearnPoint Routes */}
      <Route path="/learnpoint" element={<LearnPointLayout />}>
        <Route path="infoSection/:Type" element={<LearnPointLayout />} />
      </Route>

      {/* CenterPoint Routes */}
      <Route path="/centerpoint" element={<CenterPointLayout />}>
        <Route path=":Type" element={<CenterPointLayout />} />
      </Route>

      {/* Core Ratio Routes */}
      <Route path="/coreratio" element={<CoreRatioLayout />}>
        <Route path=":Type" element={<CoreRatioLayout />} />
      </Route>

      {/* Search Routes - Standalone with parameters */}
      <Route path={SEARCH_RESULT} element={<SearchResult />} />
      <Route path={PARENT_CLIENT} element={<ParentClient />} />
      <Route path={REQUISITION_SEARCH} element={<RequisitionSearch />} />
      <Route path={ROSTER_SEARCH} element={<RosterSearch />} />

      {/* Roster Configuration Routes */}
      <Route path={ROSTER_CONFIG} element={<RosterConfig />} />
      <Route path={NEW_ROSTER_CONFIG} element={<NewRosterConfig />} />

      {/* Bulk Edit Routes */}
      <Route path={BULK_EDIT} element={<BulkEdit />} />
      <Route path={ATTENDANCE} element={<Attendance />} />

      {/* Trainee Details Route */}
      <Route path={TRAINEE_DETAILS} element={<TraineeDetails />} />

      {/* PII Report Routes */}
      <Route path={PII_REPORT} element={<PIIReport />} />
      <Route path={PII_REPORT_BY_ORACLEID} element={<PIIReportByOracleId />} />
      <Route path={PII_RITM_REPORT} element={<PIIReportByRITM />} />

      {/* IDM Ticket Routes */}
      <Route path={CREATE_IDM_TICKET} element={<CreateIDMTicket />} />

      {/* Milestones Routes */}
      <Route path={MILESTONES} element={<MileStones />} />
      <Route path={CREATEMILESTONES} element={<CreateMilestones />} />

      {/* Shipping Report Route */}
      <Route path={SHIPPING_REPORT} element={<ShippingReportAccess />} />

      {/* Facilities Report Route */}
      <Route path={PII_FACILITIES_REPORT} element={<PIIReportByFacilities />} />

      {/* Report Routes */}
      <Route path={PII_FACILITIES_REPORT} element={<PIIReportByFacilities />} />

      {/* Report Routes*/}
      <Route path="/biReport" element={<BIReportLayout />}>
        <Route path=":Type" element={<BIReportLayout />} />
        <Route path="loginsights" element={<BIReportLayout />} />
      </Route>

      {/* 404 Not Found - Must be last route */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
